import React, { forwardRef } from 'react';
import cn from 'classnames';

var styles = {"component":"code-input__component_71x65","input":"code-input__input_71x65","hasError":"code-input__hasError_71x65","disabled":"code-input__disabled_71x65","compact":"code-input__compact_71x65"};
require('./index.css');

var Input = forwardRef(function (_a, ref) {
    var _b;
    var index = _a.index, error = _a.error, disabled = _a.disabled, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.compact, compact = _d === void 0 ? false : _d, onChange = _a.onChange, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, _e = _a.stylesInput, stylesInput = _e === void 0 ? {} : _e;
    var handleChange = function (event) {
        onChange(event, { index: index });
    };
    var handleKeyDown = function (event) {
        onKeyDown(event, { index: index });
    };
    var handleClick = function (event) {
        event.persist();
        var target = event.target;
        /**
         * В сафари выделение корректно работает только с асинхронным вызовом
         */
        requestAnimationFrame(function () {
            target === null || target === void 0 ? void 0 : target.select();
        });
    };
    return (React.createElement("input", { ref: ref, className: cn(styles.input, stylesInput.component, (_b = {},
            _b[styles.hasError] = error,
            _b[stylesInput.hasError] = error,
            _b[styles.disabled] = disabled,
            _b[stylesInput.disabled] = disabled,
            _b[styles.compact] = compact,
            _b[stylesInput.compact] = Boolean(stylesInput.compact) && compact,
            _b)), disabled: disabled, value: value, autoComplete: index === 0 ? 'one-time-code' : '', inputMode: 'numeric', pattern: '[0-9]*', onChange: handleChange, onKeyDown: handleKeyDown, onFocus: onFocus, onClick: handleClick }));
});

export { Input };
